import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { authReducer } from 'data_system/token_auth/reducer';
import { initialPropsReducer } from './initialPropsReducer';
import { resourceReducer } from './resourceReducer';
import { slotsReducer } from './slotsReducer';
import experienceReducer from './experienceReducer';

export const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    initialProps: initialPropsReducer,
    auth: authReducer,
    resource: resourceReducer,
    slots: slotsReducer,
    experienceReducer,
  });
